<div class="header" [class.rtl]="layoutService.websiteDirection$.value === 'rtl'">
  <div class="container">
    <div class="row align-center header__row">
      <div class="flex align-center justify-flex-end">
      <div class="d-none-md col-auto cursor-pointer mr-auto" [routerLink]="RoutesUtil.Dashboard.url()">
        <app-logo [type]="'symbol'" [customLogo]="userLogo"></app-logo>
      </div>

        <div class="flex align-center mr-md-auto">
          <div class="col-auto">
            <app-search></app-search>
          </div>
        </div>

          <div class="flex align-center">
            <!-- Bid chat (#47189): the customer's Chat logs; the async badge only subscribes when shown. -->
            <ng-container *ngIf="isChatEnabled$ | async">
              <ng-template grantBiddingAccess [grantBiddingAccessOnlyIf]="isCustomer">
                <button
                  mat-button
                  type="button"
                  class="header__chat-button d-inline"
                  [matTooltip]="'bidChat.ChatLogs' | translate"
                  [attr.aria-label]="'bidChat.ChatLogs' | translate"
                  (click)="onChatButtonClicked()"
                >
                  <mat-icon
                    *ngIf="{ count: (chatUnreadCount$ | async) || 0 } as chat"
                    [matBadge]="chat.count > 99 ? '99+' : chat.count"
                    [matBadgeHidden]="chat.count < 1"
                    [matBadgeDescription]="'bidChat.UnreadMessages' | translate: { count: chat.count }"
                    matBadgeSize="small"
                    [matBadgeColor]="'warn'"
                    class="icon icon--small d-inline align-center"
                  >
                    <app-icon class="d-inline align-middle text-primary-200" name="outline-message-text"></app-icon>
                  </mat-icon>
                </button>
              </ng-template>
            </ng-container>

            <div class="header__notification-icon px-5 mx-5">
              <button mat-button (click)="onNotificationsButtonClicked()" class="d-inline">
                <mat-icon
                  [matBadge]="unreadCount > 99 ? '99+': unreadCount"
                  [matBadgeHidden]="unreadCount < 1"
                  matBadgeSize="small"
                  [matBadgeColor]="'warn'"
                  class="icon icon--small d-inline align-center">
                  <app-icon class="d-inline align-middle text-primary-200" name="outline-notification"></app-icon>
                </mat-icon>
              </button>
            </div>

            <div class="d-none d-block-md">
              <button
                mat-button
                class="d-none d-inline-block-sm h-100"
                [popoverTrigger]="popoverMenu"
                #popoverInstance="popoverTrigger"
                [closeOnClickOutside]="true"
                [position]="position"
              >
                <span class="flex align-center">
                  <app-avatar
                    class="mr-3"
                    [name]="userFullName"
                    [round]="true"
                    radius="50"
                    bgColor="var(--color-accent)"
                    fgColor="var(--color-white)"
                    size="38"
                    >
                  </app-avatar>

                  <span class="flex column align-center">
                    <span class="header__user-name text-900 mb-0">{{ userFullName | titlecase }}</span>
                    <span dir="ltr" class="header__user-phone small mb-0 text-primary-300" *ngIf="userMobileNumber">{{userMobileNumber}}</span>
                  </span>
                  <app-icon class="ml-2" size="xs" name="outline-arrow-down"></app-icon>
                </span>
              </button>

              <ng-template #popoverMenu>
                <mat-nav-list class="header__popover-container">
                  <mat-list-item class="my-3">
                    <div class="flex align-center">
                      <img class="mr-2" src="../../../../assets/images/avatar.med.svg" />
                      <div class="flex column m">
                        <span class="header__avatar-title">{{ userFullName | titlecase }}</span>
                        <span class="header__avatar-subtitle">{{userEmail}}</span>
                      </div>
                    </div>
                  </mat-list-item>

                  <mat-divider></mat-divider>

                  <app-avatar-Menu
                  (click)="popoverInstance.close()"></app-avatar-Menu>
                  <div class="flex align-center justify-center m-2 text-400 small font-weight-normal">V{{ConfigConstant.VERSION}}</div>
                </mat-nav-list>
              </ng-template>
            </div>
          </div>

          <div class="col-auto d-block d-none-md" [ngClass]="{ 'navbar--active': openMenu }">
            <button
              mat-icon-button
              (click)="handelClick()"
              class="navbar__toggle"
              >

              <span class="navbar__toggle-bars">
                <span class="navbar__toggle-bar"></span>
                <span class="navbar__toggle-bar"></span>
                <span class="navbar__toggle-bar"></span>
              </span>
            </button>

          </div>
      </div>
    </div>
  </div>
</div>
